var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55351 7.44657C9.55351 4.43956 11.9912 2.00189 14.9982 2.00189C18.0052 2.00189 20.4429 4.43956 20.4429 7.44657C20.4429 10.4536 18.0052 12.8912 14.9982 12.8912C11.9912 12.8912 9.55351 10.4536 9.55351 7.44657ZM14.9982 0C10.8856 0 7.55162 3.33394 7.55162 7.44657C7.55162 11.5592 10.8856 14.8931 14.9982 14.8931C19.1108 14.8931 22.4448 11.5592 22.4448 7.44657C22.4448 3.33394 19.1108 0 14.9982 0ZM0.390625 28.8527V29.8537H29.6074V28.8527C29.6074 23.7612 26.0596 19.4871 21.1424 17.5433C19.2712 16.8036 17.1889 16.3929 14.999 16.3929C10.6929 16.3929 6.79286 17.9821 4.10247 20.549C1.8144 22.732 0.390625 25.6377 0.390625 28.8527ZM5.48439 21.9974C7.78076 19.8064 11.1768 18.3948 14.999 18.3948C16.9388 18.3948 18.7713 18.7586 20.4064 19.405C24.3863 20.9783 27.1246 24.178 27.5481 27.8518H2.44966C2.70334 25.6419 3.79047 23.6136 5.48439 21.9974Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bfdea614.svg";
export { ForwardRef as ReactComponent };